import { render, staticRenderFns } from "./TabPanelDados.vue?vue&type=template&id=17835018&scoped=true&"
import script from "./TabPanelDados.vue?vue&type=script&lang=js&"
export * from "./TabPanelDados.vue?vue&type=script&lang=js&"
import style0 from "./TabPanelDados.vue?vue&type=style&index=0&id=17835018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17835018",
  null
  
)

export default component.exports